var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleScheduleBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.30579 2.25488H9.22394V9.77166H2.30579V2.25488Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.84338 0.751465H7.6868V2.25482H3.84338V0.751465Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.57653 0.939597H8.96798C9.83276 0.939597 10.5338 1.60065 10.5338 2.41611V9.26175C10.5338 10.0772 9.83276 10.7383 8.96798 10.7383H2.70463C1.83984 10.7383 1.13879 10.0772 1.13879 9.26175V2.41611C1.13879 1.60065 1.83984 0.939597 2.70463 0.939597H3.09607C3.32385 0.389617 3.89125 0 4.55516 0H7.11744C7.78135 0 8.34876 0.389617 8.57653 0.939597ZM3.04827 2.28188H2.70463C2.62601 2.28188 2.56228 2.34198 2.56228 2.41611V9.26175C2.56228 9.33588 2.62601 9.39597 2.70463 9.39597H8.96798C9.04659 9.39597 9.11032 9.33588 9.11032 9.26175V2.41611C9.11032 2.34198 9.04659 2.28188 8.96798 2.28188H8.62434C8.43845 2.90161 7.83418 3.35571 7.11744 3.35571H4.55516C3.83842 3.35571 3.23416 2.90161 3.04827 2.28188ZM4.41282 1.47651C4.41282 1.40238 4.47655 1.34228 4.55516 1.34228H7.11744C7.19606 1.34228 7.25979 1.40238 7.25979 1.47651V1.87919C7.25979 1.95333 7.19606 2.01342 7.11744 2.01342H4.55516C4.47655 2.01342 4.41282 1.95333 4.41282 1.87919V1.47651Z",
    fill: "#5062F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.13168 4.83222C3.13168 4.46155 3.45034 4.16107 3.84342 4.16107H7.82919C8.22227 4.16107 8.54093 4.46155 8.54093 4.83222C8.54093 5.20288 8.22227 5.50336 7.82919 5.50336H3.84342C3.45034 5.50336 3.13168 5.20288 3.13168 4.83222Z",
    fill: "#5062F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.13168 7.51678C3.13168 7.14612 3.45034 6.84564 3.84342 6.84564H7.82919C8.22227 6.84564 8.54093 7.14612 8.54093 7.51678C8.54093 7.88744 8.22227 8.18792 7.82919 8.18792H3.84342C3.45034 8.18792 3.13168 7.88744 3.13168 7.51678Z",
    fill: "#5062F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91797 7.5166H13.8361V15.0334H6.91797V7.5166Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.45544 6.01318H12.2989V7.51654H8.45544V6.01318Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1887 6.20132H13.5802C14.4449 6.20132 15.146 6.86237 15.146 7.67783V14.5235C15.146 15.3389 14.4449 16 13.5802 16H7.31681C6.45203 16 5.75098 15.3389 5.75098 14.5235V7.67783C5.75098 6.86237 6.45203 6.20132 7.31681 6.20132H7.70825C7.93603 5.65134 8.50344 5.26172 9.16735 5.26172H11.7296C12.3935 5.26172 12.9609 5.65134 13.1887 6.20132ZM7.66045 7.5436H7.31681C7.2382 7.5436 7.17446 7.60369 7.17446 7.67783V14.5235C7.17446 14.5976 7.2382 14.6577 7.31681 14.6577H13.5802C13.6588 14.6577 13.7225 14.5976 13.7225 14.5235V7.67783C13.7225 7.60369 13.6588 7.5436 13.5802 7.5436H13.2365C13.0506 8.16333 12.4464 8.61742 11.7296 8.61742H9.16735C8.45061 8.61742 7.84634 8.16333 7.66045 7.5436ZM9.025 6.73823C9.025 6.6641 9.08873 6.604 9.16735 6.604H11.7296C11.8082 6.604 11.872 6.6641 11.872 6.73823V7.14091C11.872 7.21505 11.8082 7.27514 11.7296 7.27514H9.16735C9.08873 7.27514 9.025 7.21505 9.025 7.14091V6.73823Z",
    fill: "#5062F0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.74386 10.0939C7.74386 9.72327 8.06252 9.42279 8.4556 9.42279H12.4414C12.8345 9.42279 13.1531 9.72327 13.1531 10.0939C13.1531 10.4646 12.8345 10.7651 12.4414 10.7651H8.4556C8.06252 10.7651 7.74386 10.4646 7.74386 10.0939Z",
    fill: "#5062F0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.74386 12.7785C7.74386 12.4078 8.06252 12.1074 8.4556 12.1074H12.4414C12.8345 12.1074 13.1531 12.4078 13.1531 12.7785C13.1531 13.1492 12.8345 13.4496 12.4414 13.4496H8.4556C8.06252 13.4496 7.74386 13.1492 7.74386 12.7785Z",
    fill: "#5062F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleScheduleBlue);
export default __webpack_public_path__ + "static/media/doubleScheduleBlue.3042a988df1a0999a7c706a340708feb.svg";
export { ForwardRef as ReactComponent };